var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0.5C5.49706 0.5 5.9 0.902944 5.9 1.4V4.1L8.6 4.1C9.09706 4.1 9.5 4.50294 9.5 5C9.5 5.49706 9.09705 5.9 8.6 5.9H5.9V8.6C5.9 9.09706 5.49706 9.5 5 9.5C4.50294 9.5 4.1 9.09706 4.1 8.6V5.9H1.4C0.902944 5.9 0.5 5.49706 0.5 5C0.5 4.50294 0.902944 4.1 1.4 4.1L4.1 4.1V1.4C4.1 0.902944 4.50294 0.5 5 0.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.5c77cd4c5a14a450c84591dc748e3b6c.svg";
export { ForwardRef as ReactComponent };